class EmailPopup extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('dialog');
    this.form = this.querySelector('form');
    this.closeButtons = this.querySelectorAll('.close-button');
    this.content = this.querySelector('.email-popup__content');
    this.successMessage = this.querySelector('.email-popup__success');

    this.closeButtons?.forEach((btn) => {
      btn.addEventListener('click', () => this.close());
    });

    this.dialog?.addEventListener('click', (e) => {
      if (e.target === this.dialog) this.close();
    });

    this.form?.addEventListener('submit', this.handleSubmit.bind(this));
  }

  open() {
    this.dialog?.showModal();
    // Reset state
    if (this.content) this.content.style.display = 'block';
    if (this.successMessage) this.successMessage.style.display = 'none';
    this.form?.reset();
  }

  close() {
    this.dialog.close();
  }

  async handleSubmit(e) {
    e.preventDefault();
    const email = this.form?.querySelector('input[name="email"]')?.value || '';
    const firstname =
      this.form?.querySelector('input[name="firstname"]')?.value || '';
    const lastname =
      this.form?.querySelector('input[name="lastname"]')?.value || '';
    const phone = this.form?.querySelector('input[name="phone"]')?.value || '';
    const submitBtn = this.form?.querySelector('button[type="submit"]');

    if (submitBtn) {
      // Disable button to prevent multiple submits
      submitBtn.disabled = true;
      submitBtn.textContent = 'Senden...';
    }

    try {
      const API_ENDPOINT = 'https://lottery.activated-web.com/api/code/extra';
      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-competition-id': '697379dea63903315aa4238b',
        },
        body: JSON.stringify({
          email: email,
          firstname: firstname,
          lastname: lastname,
          phone: phone,
          secretSauce: 'nobueno',
        }),
      });

      // Parse the JSON response
      if (response.ok) {
        // On success
        this.content.style.display = 'none';
        this.successMessage.style.display = 'block';
      } else {
        alert(
          'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
        );
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.');
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Senden';
      }
    }
  }
}

if (!customElements.get('email-popup')) {
  customElements.define('email-popup', EmailPopup);
}

const popupTrigger = document.querySelector('.email-popup-trigger');
if (popupTrigger) {
  popupTrigger.addEventListener('click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    const popup = document.querySelector('email-popup');
    if (popup) popup.open();
    return;
  });
}
// document.addEventListener('click', (e) => {
//   e.stopPropagation();
//   e.preventDefault();
//   if (e.target === document.querySelector('.email-popup-trigger')) {
//     const popup = docum  ent.querySelector('email-popup');
//     if (popup) popup.open();
//     return;
//   }
// });
